import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {trigger, style, animate, transition, state} from '@angular/animations';
import { Router } from '@angular/router';
import { ReportService } from '../../core/http/report.service'

import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-report-template',
  templateUrl: './create-report-template.component.html',
  styleUrls: ['./create-report-template.component.scss']
})
export class CreateReportTemplateComponent implements OnInit {

  isLoading = false;
  Errors;
  success: any = [];
  data: any = [];
  templates: any = [];

  constructor(public report:ReportService,  private _snackBar: MatSnackBar) { }

  ngOnInit(): void {

    this.report
    .getReportTypes()
    .subscribe(
      (resSuccess) => {

        this.data = resSuccess
        this.templates = this.data.Result
        console.log(this.data)
        console.log(this.templates)
      },
      (resErr) => {
        this.Errors = resErr;
      }
    ); 
  }

  Form = new FormGroup({
    name: new FormControl(''),
    description: new FormControl(''),
    moduleCode: new FormControl(''),
    reportType: new FormControl(''),
    queryText: new FormControl(''),
    id: new FormControl(0),
    
  });

  onSubmit(e) {
    e.preventDefault();
      this.isLoading = true;
      this.Errors = null;
      console.log(this.Form.value)
      const {
        name,
        description,
        moduleCode,
        reportType,
        queryText,
        id
      } = this.Form.value;
      console.log(this.Form.value)
      this.report
        .createReportTemplate(
          name,
          description,
          moduleCode,
          reportType,
          queryText,
          id,
        )
        .subscribe(
          (resSuccess) => {
  
            this.success = resSuccess
            this.isLoading = false;
            console.log(resSuccess)
            console.log(this.success)
  
            if (this.success) {

              if (!this.success.HasError) {
                this._snackBar.open('Saved Successfully', '', {
                  duration: 2000,
                  verticalPosition: 'top',
                }); 
                this.Form.reset()
              }
              else {
                this._snackBar.open('Error: please try again', '', {
                  duration: 2000,
                  verticalPosition: 'top',
                });
              }
            }
            else {
              this.Errors = "Not successful, please try again"
              this._snackBar.open('Error: please try again', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
     
              console.log(resSuccess)
            }
            
          },
          (resErr) => {
            this.isLoading = false; 
            this.Errors = resErr;
            // this.toastService.show(`Error -  something went wrong`, { classname: 'bg-danger text-light', delay: 3000 });
            console.log(resErr)
          }
        );
  }


}
